import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Button, Card, Col, Input, InputNumber, Modal, Row } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import '../../../../styles/pages/busk/components/_settlement-detail.scss';
import { dateFormat } from '../../utils/date';
import { inquiryStatus } from '../../utils/status';
import settlement from '../services/settlement';
import { ILogisticsCenterDetail } from '../types/settlement.interface';

const LogisticsCenterDetail = () => {
  const [isManual, setIsManual] = useState<boolean>(false);
  const [serviceAmount, setServiceAmount] = useState<number>(0.0);
  const [logisticsCenter, setLogisticsCenter] =
    useState<ILogisticsCenterDetail | null>(null);
  const { id }: any = useParams();
  const history = useHistory();
  const inputRef = useRef<HTMLInputElement>(null);

  const breadcrumbList = [
    {
      tittle: '정산 관리',
      url: '/admin/busk/settlement'
    },
    {
      tittle: '물류센터 정산 조회',
      url: '/admin/busk/warehouse-settlement'
    },
    {
      tittle: '물류센터 정산 조회 상세',
      url: ''
    }
  ];

  const getLogisticsCenterDetail = useCallback(async () => {
    const res = await settlement.getLogisticsCenterDetail(id);
    const serviceStatus = inquiryStatus(res?.data?.serviceStatus);
    if (res?.data?.serviceAmount) {
      setServiceAmount(res?.data?.serviceAmount);
    }
    setLogisticsCenter({
      ...res?.data,
      status: serviceStatus,
      start: dateFormat(res?.data?.periodStart),
      end: dateFormat(res?.data?.periodEnd)
    });
  }, [id]);

  useEffect(() => {
    getLogisticsCenterDetail();
  }, [getLogisticsCenterDetail]);

  const onRequest = async () => {
    const res = await settlement.createInquiryService(id, serviceAmount);
    if (res) {
      history.push('/admin/busk/warehouse-settlement');
    }
  };

  const { confirm } = Modal;

  const showConfirm = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: '전송하시겠습니까?',
      content: '확인을 클릭하면 해당 물류센터에 수수료 청구서를 발송합니다.',
      icon: false,
      centered: true,
      okText: '확인',
      cancelText: '취소',
      onOk() {
        onRequest();
      },
      onCancel() {}
    });
  };

  const changeManualMode = () => {
    if (!isManual) {
      setIsManual(true);
      setTimeout(() => {
        inputRef?.current?.focus();
      }, 100);
    }
  };

  const onDownload = () => {
    if (logisticsCenter?.billingInquiryFile?.url)
      window.open(logisticsCenter.billingInquiryFile.url, '_blank', 'noopener');
  };

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="settlement-detail">
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={8} className="settlement-info-left">
            <Card bordered={false}>
              <div className="label">
                <p>판매자 사업자명</p>
                <p>거래 물류센터명</p>
                <p>영수증 번호</p>
              </div>
              <div className="value">
                <p>{logisticsCenter?.seller?.name}</p>
                <p>{logisticsCenter?.warehouse?.name}</p>
                <p>{logisticsCenter?.receiptId}</p>
              </div>
            </Card>
          </Col>
          <Col xs={24} lg={16} className="settlement-info-right">
            <Card bordered={false}>
              <div className="settlement-info-right-item">
                <p className="item-title">From.</p>
                <p>
                  <span className="item-name">
                    {logisticsCenter?.admin?.name}
                  </span>
                  <span className="item-country">
                    {logisticsCenter?.admin?.country}
                  </span>
                </p>
                <p className="item-phone">
                  <span className="label">Tel</span>{' '}
                  {`${logisticsCenter?.admin?.countryCode ?? ''} ${
                    logisticsCenter?.admin?.phoneNumber ?? ''
                  }`}
                </p>
                <p className="item-mail">
                  <span className="label">Email</span>{' '}
                  {logisticsCenter?.admin?.email}
                </p>
                <p className="address">
                  {logisticsCenter?.admin?.detailAddress}
                </p>
                <p></p>
              </div>
              <div className="settlement-info-right-item">
                <p className="item-title">To.</p>
                <p>
                  <span className="item-name">
                    {logisticsCenter?.warehouse?.name}
                  </span>
                  <span className="item-country">
                    {logisticsCenter?.warehouse?.country}
                  </span>
                </p>
                <p className="item-phone">
                  <span className="label">Tel</span>{' '}
                  {`${logisticsCenter?.warehouse?.countryCode ?? ''} ${
                    logisticsCenter?.warehouse?.phoneNumber ?? ''
                  }`}
                </p>
                <p className="item-mail">
                  <span className="label">Email</span>{' '}
                  {logisticsCenter?.warehouse?.email}
                </p>
                <p className="address">
                  {logisticsCenter?.warehouse?.detailAddress}
                </p>
              </div>
            </Card>
          </Col>
          <Col span={24}>
            <Card className="section-content-layout" bordered={false}>
              {logisticsCenter?.serviceStatus !== 'New' && (
                <div className="settlement-status">
                  <div
                    className={
                      'settlement-status-content' +
                      (logisticsCenter?.serviceStatus === 'Request'
                        ? ' request'
                        : ' completed')
                    }
                  >
                    {logisticsCenter?.status}
                  </div>
                </div>
              )}
              <div className="section-content">
                <div className="section-content-header">
                  <div className="label">서비스 이용 내역</div>
                  <div>
                    {' '}
                    {logisticsCenter?.start} ~ {logisticsCenter?.end}
                  </div>
                </div>
                <Row gutter={0} className="section-content-body">
                  <Col xs={6} className="item-label">
                    물류센터 입고 상품 종류
                  </Col>
                  <Col xs={18} className="item-value">
                    <hr className="dotted" />
                    <div className="value">
                      {logisticsCenter?.numberProductTypes ?? 0}
                    </div>
                  </Col>
                  <Col xs={6} className="item-label">
                    총 주문 상품 개수
                  </Col>
                  <Col xs={18} className="item-value">
                    <hr className="dotted" />
                    <div className="value">
                      {logisticsCenter?.orderCounts ?? 0}
                    </div>
                  </Col>
                  <Col span={24} className="sub-title">
                    입고 내역
                  </Col>
                  <Col xs={6} className="item-label">
                    물류센터 입고 상품 개수
                  </Col>
                  <Col xs={18} className="item-value">
                    <hr className="dotted" />
                    <div className="value">
                      {logisticsCenter?.numberDelivered ?? 0}
                    </div>
                  </Col>
                  <Col xs={6} className="item-label">
                    판매자 반송 상품 개수
                  </Col>
                  <Col xs={18} className="item-value">
                    <hr className="dotted" />
                    <div className="value">
                      {logisticsCenter?.numberReturn ?? 0}
                    </div>
                  </Col>
                  <Col xs={6} className="item-label">
                    폐기 상품 개수
                  </Col>
                  <Col xs={18} className="item-value">
                    <hr className="dotted" />
                    <div className="value">
                      {logisticsCenter?.numberDisposal ?? 0}
                    </div>
                  </Col>
                  <Col xs={6} className="item-label-total-payment">
                    총 결제 금액
                  </Col>
                  <Col xs={18} className="item-value-total-payment">
                    <hr className="dotted" />
                    <div className="value">
                      {`US$ ${logisticsCenter?.billingAmount ?? 0}`}
                    </div>
                  </Col>
                  <Col xs={6} className="item-label-request-fee">
                    요청 수수료
                  </Col>
                  <Col xs={18} className="item-value-request-fee">
                    <hr className="dotted" />
                    <div className="value">
                      {isManual ? (
                        <InputNumber
                          controls={false}
                          value={serviceAmount}
                          onChange={(val) => {
                            setServiceAmount(val ?? 0);
                          }}
                          formatter={(value) => {
                            const splitted = String(value).split('.');
                            let newValue = String(value);
                            if (String(value).includes('.')) {
                              newValue =
                                splitted[0] + '.' + splitted[1].slice(0, 2);
                            }
                            return `${newValue}`.replace(
                              /\B(?=(\d{3})+(?!\d))/g,
                              ','
                            );
                          }}
                          parser={(value) => {
                            const splitted = String(value).split('.');
                            if (String(value).includes('.')) {
                              value =
                                splitted[0] + '.' + splitted[1].slice(0, 2);
                            }
                            return parseFloat(
                              value!.replace(/\$\s?|(,*)/g, '')
                            );
                          }}
                          min={0}
                          step="0.01"
                          prefix="US$"
                          type="text"
                          ref={inputRef}
                        />
                      ) : (
                        <Input prefix="US$" value={serviceAmount} disabled />
                      )}
                    </div>
                  </Col>
                  {logisticsCenter?.serviceStatus === 'New' && (
                    <>
                      <Col xs={6} className="request-fee-description">
                        총 결제금액의 12% 적용, 직접 입력 가능
                      </Col>
                      <Col xs={18} className="request-fee-directly">
                        <u onClick={changeManualMode}>직접 입력하기</u>
                      </Col>
                    </>
                  )}
                </Row>
                <div className="section-content-footer">
                  <Button className="btn-download" onClick={onDownload}>
                    거래 명세서 다운로드
                  </Button>
                  {logisticsCenter?.serviceStatus === 'New' && (
                    <Button
                      className="btn-request"
                      onClick={showConfirm}
                      disabled={!serviceAmount}
                    >
                      결제 요청서 전송
                    </Button>
                  )}
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LogisticsCenterDetail;
